/*
 * simulateStream — llama al endpoint SSE autenticado `/api/merchants/me/sales-ai/simulate`.
 * A diferencia de chatStream.js, este helper adjunta el Bearer token del merchant.
 */

import { devWarn } from "./devLog";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export async function simulateStream({ text, sessionId, reset = false, onChunk, onDone, onError, signal }) {
  try {
    const token = localStorage.getItem("holaradar_merchant_token");
    if (!token) {
      onError?.("No autenticado");
      return;
    }
    const res = await fetch(`${BACKEND_URL}/api/merchants/me/sales-ai/simulate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ text, session_id: sessionId, reset }),
      signal,
    });

    if (!res.ok || !res.body) {
      const err = await res.text().catch(() => "network");
      onError?.(err || `HTTP ${res.status}`);
      return;
    }

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let fullText = "";

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });

      let idx;
      while ((idx = buffer.indexOf("\n\n")) !== -1) {
        const frame = buffer.slice(0, idx);
        buffer = buffer.slice(idx + 2);

        for (const line of frame.split("\n")) {
          if (!line.startsWith("data:")) continue;
          const payload = line.slice(5).trim();
          if (!payload) continue;
          try {
            const evt = JSON.parse(payload);
            if (evt.type === "chunk") {
              fullText += evt.text;
              onChunk?.(evt.text);
            } else if (evt.type === "done") {
              onDone?.({ full: evt.full || fullText, usage: evt.usage || null });
              return;
            } else if (evt.type === "error") {
              onError?.(evt.detail || "AI error");
              return;
            }
          } catch (parseErr) {
            if (payload.length > 0 && payload[0] === "{") {
              devWarn("[simulateStream] malformed frame:", payload.slice(0, 80), parseErr?.message);
            }
          }
        }
      }
    }
    onDone?.({ full: fullText, usage: null });
  } catch (e) {
    if (e?.name === "AbortError") return;
    onError?.(e?.message || String(e));
  }
}
